import React from 'react';

import { useCompleteModal } from 'modal.react.js';
import { Field, Form } from 'react-final-form';

import { AModal } from 'components/shared/AModal';
import ArrayFields from 'components/shared/ArrayFields';
import Button from 'components/shared/Button';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import Text from 'components/shared/Typography/Text';
import { ENTER_VIDEO_HOST_LINK, SYMBOLS_LIMIT } from 'constants/texts';

import Images from '../../Resources/Upload/Images';
import { useRoomForm } from '../functions';
import s from './RoomFormModal.module.css';
import * as t from './RoomFormModal.types';

export const RoomFormModal = (props: t.Props) => {
  const res = useCompleteModal<boolean>();
  const { data, openModal, onDelete, validate, onRoomNameChange, onReorder } = useRoomForm({
    room: props.room,
    page: props.page,
  });

  return (
    <AModal header="Add Room" isOpen onClose={() => res.success(false)} size="lmd" bodyClassName={s.modalBody}>
      <Form
        onSubmit={props.onSubmit}
        initialValues={props.room}
        validate={validate(props.page)}
        render={({ handleSubmit, values, hasValidationErrors, form }) => {
          return (
            <form onSubmit={handleSubmit} autoComplete="nope">
              <div className={s.label}>
                <Text type="brandon" size="regular">
                  Room Type
                </Text>
                <Text type="brandon" size="regular" color="gray-500">
                  &nbsp;(e.g. Standard Tent)
                </Text>
              </div>

              <Field
                component={FormGroupAdapter}
                name="name"
                placeholder="Room Type"
                type="text"
                onCustomChange={onRoomNameChange}
                parse={(value) => value}
                noTransform
                className={s.roomName}
              />

              <Field
                component={FormGroupAdapter}
                name="description"
                placeholder="Room Description..."
                type="textarea"
                parse={(value) => value}
                minRows={5}
                maxLength={SYMBOLS_LIMIT}
                hideMaxLength
              />

              <Images
                files={values.media}
                form={form}
                onOpenModal={openModal}
                onDelete={onDelete}
                name="media"
                onReorder={onReorder(form)}
              />

              <div className={s.label}>
                <Text type="brandon" size="regular">
                  Videos
                </Text>
                <Text type="brandon" size="regular" color="gray-500">
                  &nbsp;(Enter YouTube, Vimeo or Wistia Link)
                </Text>
              </div>

              <div className={s.videoWrapper}>
                <ArrayFields
                  initialValues={data}
                  data={{
                    sectionName: 'videos',
                    config: { twoColumn: true },
                    fieldsData: [
                      {
                        name: 'name',
                        placeholder: 'Video Name',
                        label: '',
                      },
                      {
                        name: 'link',
                        placeholder: ENTER_VIDEO_HOST_LINK,
                        label: '',
                      },
                    ],
                  }}
                />
              </div>

              <div className={s.footer}>
                <Button type="primary" disabled={hasValidationErrors} isWidthFitContent size="medium">
                  Save
                </Button>
              </div>
            </form>
          );
        }}
      />
    </AModal>
  );
};
